import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './plugins/element.js'


import './directives/index'

import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'

import qs from 'qs'
Vue.prototype.$qs = qs;

// 加密
import CryptoJS from 'crypto-js'
Vue.prototype.$CryptoJS = CryptoJS;

// import '../public/js/message'
// require('../public/js/message');
import echarts from 'echarts'
import 'echarts-liquidfill'
Vue.prototype.$echarts = echarts

import ECharts from 'vue-echarts'

// 手动引入 ECharts 各模块来减小打包体积
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/pie';

Vue.component('v-chart', ECharts)

import './assets/css/public.css' 
import '@/styles/index.scss' // global css
import '@/styles/animate.css'

import 'video.js/dist/video-js.css'
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)
require('vue-video-player/src/custom-theme.css')


// Vue.prototype.$config = config

import formatData from "@/assets/js/formatData"
import common from "@/assets/js/common"

// 屏幕适配
import '@/assets/js/flexible'

let projectKey = window.localStorage.getItem("project") || "1";
Vue.prototype.$project = {key: projectKey, projectData: window.project_config[projectKey]};

Vue.prototype.Messenger = window.Messenger;
Vue.prototype.$axios = axios.create({
  headers: {
    "organizeId": window.project_config[projectKey].platform.organizeId,
    "PlanId": window.project_config[projectKey].platform.progressLoadingPlanId,
  }
});
Vue.prototype.$ECharts = ECharts
Vue.prototype.$formatData = formatData
Vue.prototype.$common = common

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
